function Portfolio(){
    return(
        <div className="experience">
            <h1>Portfolio</h1>
            
            <h3>I'm Productive<span>Astra Toyota Motor</span></h3>
            <p>An application to monitor employee productivity levels and an application to submit new ideas and concepts</p>
            
            <h3>System Information Mahad<span>Ibnu Hajar Boarding School</span></h3>
            <p>A application for managing grades and student health reports</p>
            
            <h3>E-Library<span>Ibnu Hajar Boarding School</span></h3>
            <p>A web that contains various types of books, and you can read them</p>
            
            <h3>Circel Student<span>Ibnu Hajar Boarding School</span></h3>
            <p>School management system, including report cards and learning content</p>
            
            <h3>Company Profile<span>Standard Plus</span></h3>
            <p>A company profile website</p>
            
            <h3>Sistem Pabrikasi<span>PT. Klip Plastik Indonesia</span></h3>
            <p>An integrated system from the marketing process to the production process to packaging</p>
            
            <h3>www.klipplastik.co.id<span>PT. Klip Plastik Indonesia</span></h3>
            <p>A company profile website and online shop product</p>
        </div>
    );
}

export default Portfolio;